<div
  [ngClass]="{
    'input-field': true,
    'input-field--invalid': invalid,
  }"
>
  <div class="form-control-container">
    @if (label) {
      <label class="form-label" [htmlFor]="id">{{ label }}</label>
    }

    <div class="d-flex gap-2">
      @for (i of [].constructor(length); track $index; let idx = $index) {
        <input
          #codeInput
          class="form-control"
          type="text"
          maxlength="1"
          autocomplete="one-time-code"
          title="otp"
          [id]="id"
          [attr.inputmode]="inputMode"
          [ngClass]="hostClasses"
          [value]="codeForm.get('digit' + idx)?.value"
          (input)="onInput($event, idx)"
          (keydown)="onKeyDown($event, idx)"
          (paste)="onPaste($event)"
        />
      }
    </div>

    @if (hintText) {
      <span class="form-hint-text">{{ hintText }}</span>
    }
  </div>
</div>
